import { Drawer, Grid } from '@pankod/refine-antd';

type CustomDrawerProps = {
  title: string;
  visible: boolean;
  onClose: () => void;
};

export const CustomDrawer: React.FC<CustomDrawerProps> = (props) => {
  const breakpoint = Grid.useBreakpoint();

  return (
    <Drawer
      title={props.title}
      placement="right"
      width={breakpoint.sm ? '450px' : '100%'}
      visible={props.visible}
      onClose={props.onClose}
    >
      {props.children}
    </Drawer>
  );
};
